import { useLayoutEffect, useRef, type TextareaHTMLAttributes } from "react";

export function GrowingTextarea({ value, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement> & { value: string }) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const resize = () => {
      element.style.height = "auto";
      const height = Math.min(element.scrollHeight, 340);
      element.style.height = `${height}px`;
      element.style.overflowY = element.scrollHeight > 340 ? "auto" : "hidden";
    };
    resize();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(resize);
    observer?.observe(element.parentElement ?? element);
    return () => observer?.disconnect();
  }, [value]);
  return <textarea {...props} ref={ref} value={value} />;
}
